import { gql } from 'graphql-request';

import { gqlClient } from 'graphql/gqlClient';
import { UserOrganizationType } from 'types/organization.types';

type Team = UserOrganizationType;

type ListCurrentUserTeamsQueryResult = {
  currentUserOrganizations: Team[];
};

const LIST_CURRENT_USER_TEAMS_QUERY = gql`
  query ListCurrentUserTeams {
    currentUserOrganizations {
      id
      name
    }
  }
`;

const currentUserApi = {
  listTeams: async (): Promise<Team[]> => {
    return gqlClient
      .request<ListCurrentUserTeamsQueryResult>(LIST_CURRENT_USER_TEAMS_QUERY)
      .then((res) => res.currentUserOrganizations);
  }
};

export { currentUserApi };
